import type { LDClient as LDClientV4 } from '@launchdarkly/js-client-sdk';

import { getDogfoodClient, isDogfoodClientV4 } from './getDogfoodClient';

export async function waitForDogfoodClient() {
  const timeout = 5; // seconds
  const client = getDogfoodClient();
  if (isDogfoodClientV4()) {
    await (client as LDClientV4).waitForInitialization({ timeout });
  } else {
    await client.waitForInitialization(timeout);
  }
  return client;
}
